const Helmet = (props) =>{
  document.title = "تاب30 -" + props.title;
  return <div>{props.children}</div>;
}

export default Helmet;